import Notice from './Notice';
import Account from './Account';
import Selector from './Selector';
import Clock from './Clock';

interface iConfig {
    children?: Array<{
        key: string;
        href: string;
    }>;
    signOut?: Function;
    totalCounts?: number;
    icons?: any;
    lang?: any;
    clock?: any;
    uuid?: string;
    copy?: (uuid: string) => void;
}

export default {
    Lang: Selector,
    Notice,
    Account: ({ signOut, children, uuid, copy }: iConfig) =>
        Account({ signOut, children, uuid, copy }),
    Clock: ({ lang, clock }: iConfig) => Clock({ lang, clock }),
};
